// @flow
const colorValid = "#30BF5D";
const colorInvalid = "#EF7171";

export function colorHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return colorValid;
            }
            // return "IndianRed";
            return "#DA3939";
        }
        return "#C3C3C3";
    }
    return "#C3C3C3";
}

export function textHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean, text: string): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return "Puede soltar el elemento";
            }
            return "El elemento no es permitido";
        }
        return text;
    }
    return text;
}

export function colorBackgroundHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return colorValid;
            }
            return colorInvalid;
        }
        return "#FFF";
    }
    return "#FFF";
}

export function colorTitleHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return colorValid;
            }
            return colorInvalid;
        }
        return "#A5A5A5";
    }
    return "#A5A5A5";
}

export function colorBorderHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return colorValid;
            }
            return colorInvalid;
        }
        // return "#D8D8D8";
        return "#F5F5F5";
    }
    // return "#D8D8D8";
    return "#F5F5F5";
}

export function imageBackgroundHover(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): string {
    if (isOver) {
        if (isOverCurrent) {
            if (canDrop) {
                return "url('data:image/png;base64,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')";
            }
            return "url('data:image/png;base64,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')";
        }
        return "url()";
    }
    return "url()";
}

export function validElement(isOver: boolean, canDrop: boolean, isOverCurrent: boolean): boolean {
    return isOver && isOverCurrent && canDrop;
}

export default {
    colorHover,
    textHover,
    colorBackgroundHover,
    validElement,
    colorTitleHover,
};
